@if (dialogOptions.closable) {
  <button [mat-dialog-close]="componentResult" class="dialog-close" mat-mini-fab aria-label="Close Sidebar"
    >
    <mat-icon title="Close Sidebar">close</mat-icon>
  </button>
}
@if (initialized) {
  <div class="container">
    <section>
      <div class="temp-display">
        @if (!editing) {
          <div class="mat-headline-4">{{weather.avgtemp}}&deg;</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="number" [(ngModel)]="weather.avgtemp" autocomplete="off" />
          </mat-form-field>
        }
        <div class="">
          <app-icon icon="weather/{{weather.getIcon}}.png"></app-icon>
        </div>
        <div class="icons">
          <button [disabled]="!('create' | able: dailyReport)" mat-icon-button (click)="toggleEdit()">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
      <div class="mat-caption">Temperature in {{weather.location}}</div>
    </section>
    <section>
      <div class="section-label">Temperature:</div>
      <div class="row">
        <div class="mat-body">
          Highest:
          @if (!editing) {
            {{weather.maxtemp}}&deg;
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" [(ngModel)]="weather.maxtemp" />
            </mat-form-field>
          }
        </div>
        <div class="mat-body">
          Lowest:
          @if (!editing) {
            {{weather.mintemp}}&deg;
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" [(ngModel)]="weather.mintemp" />
            </mat-form-field>
          }
        </div>
      </div>
    </section>
    <section>
      <div class="section-label">Sky condition:</div>
      <div class="mat-body">
        @if (!editing) {
          {{weather.condition?.text}}
        }
        @if (editing) {
          <mat-form-field>
            <mat-select
              (selectionChange)="onWeatherConditionChange($event.value)"
              [(value)]="weather.condition.code">
              @for (wc of weatherConditions; track wc) {
                <mat-option [value]="wc.code">
                  {{wc.text}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    </section>
    <section>
      <div class="section-label">Wind conditions(mph):</div>
      <div class="mat-body">
        @if (!editing) {
          {{weather.wind}}
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="number" [(ngModel)]="weather.wind" />
          </mat-form-field>
        }
      </div>
    </section>
    <section>
      <div class="section-label">Note:</div>
      <div class="mat-body">
        @if (!editing) {
          {{weather.notes}}
        }
        @if (editing) {
          <mat-form-field class="full-width">
            <textarea matInput type="number" [(ngModel)]="weather.notes"></textarea>
          </mat-form-field>
        }
      </div>
    </section>
    @if (editing) {
      <div class="row">
        <button [disabled]="!('create' | able: dailyReport)" mat-stroked-button color="accent" (click)="saveItem()">
          Save
        </button>
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
      </div>
    }
  </div>
}
